import { useHoneyGridApiFetch } from '@/queries/useHoneyGridApiFetch'
import { useQuery } from '@tanstack/react-query'

import type { PhoneNumber } from 'honeygrid-types'

export const phoneNumberQueryKey = (workspaceId: string, phoneNumberId: string) =>
	['phone-numbers', workspaceId, phoneNumberId] as const

/**
 * Hook to fetch a specific phone number by ID
 */
export const usePhoneNumber = (workspaceId?: string, phoneNumberId?: string) => {
	const authFetch = useHoneyGridApiFetch()

	return useQuery<PhoneNumber>({
		queryKey: phoneNumberQueryKey(workspaceId ?? '', phoneNumberId ?? ''),
		queryFn: async (): Promise<PhoneNumber> => {
			return await authFetch(`workspaces/${workspaceId}/phone-numbers/${phoneNumberId}`)
		},
		enabled: !!workspaceId && !!phoneNumberId,
	})
}
